import NutrorMainLoading from 'components/Shared/NutrorLoading';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import AppComponent from './components/App';
import { getProducerUrl } from 'actionCreators/redirect';
import { getCourseHash } from 'utils';
import { IS_STAGE, V2_URL, DISABLE_REDIRECT } from 'settings';

interface IState {
  isCorrectUrl: boolean;
}
interface IProps {
  isAuthenticated: boolean;
  redirect: {
    url?: string;
    hasError?: boolean;
  };
  getProducerUrl: Function;
}
class App extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isCorrectUrl: false,
    };
  }

  componentDidMount() {
    if (!DISABLE_REDIRECT) {
      const courseHash = getCourseHash();
      this.props.getProducerUrl(courseHash);
    }
  }

  componentDidUpdate() {
    if (!DISABLE_REDIRECT) {
      const { redirect } = this.props;
      const { origin, pathname, search } = window.location;
      const isCorrectUrl = origin === redirect?.url || redirect?.hasError || IS_STAGE;
      this.setState({ isCorrectUrl });
      if (!isCorrectUrl && redirect?.url) {
        const path = pathname.replace(/^\/v3/, '');
        const prefix = redirect?.url === V2_URL ? '/v3' : '';
        window.open(`${redirect?.url}${prefix}${path}${search}`, '_self');
      }
    }
  }

  render() {
    const { isCorrectUrl } = this.state;
    if (isCorrectUrl || DISABLE_REDIRECT)
      return (
        <div>
          <AppComponent />
        </div>
      );
    return <NutrorMainLoading />;
  }
}

const mapStateToProps = (state: any) => ({
  redirect: state.redirect,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProducerUrl,
})(App);
